import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createStoreFile } from '../../services/CommonService';

// Define the initial state for the common slice
interface CommonState {
  filepath: any; // Replace `any` with a more specific type if available
}

const initialState: CommonState = {
  filepath: null,
};

// Async thunk for fetching the store file
export const getStoreFile = createAsyncThunk(
  'common/getStoreFile',
  async (payload: any, { rejectWithValue }) => {
    try {
      const result = await createStoreFile(payload);
      return result.data; // Ensure the API returns data in the expected structure
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || 'Failed to fetch store file'
      );
    }
  }
);

// Create the common slice
const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    resetCommonState: (state) => {
      state.filepath = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getStoreFile.fulfilled,
      (state, action: PayloadAction<any>) => {
        const { filepath} = action.payload; // Destructuring for clarity
        state.filepath = filepath;
      }
    );
    builder.addCase(getStoreFile.rejected, (state, action) => {
      console.error('Failed to fetch store file:', action.payload);
    });
  },
});

// Export the actions
export const { resetCommonState } = commonSlice.actions;

// Export the reducer to be used in the store
export default commonSlice;
